export default __webpack_public_path__ + "static/media/wordpress.8bf302af.png";